const Login = () => import('@/view/user/Login.vue')

const routes = {
  path: '/Login',
  name: 'Login',
  component: Login,
}

const components = {}

export default {
  routes,
  components,
}
